import { ExportGridRef } from '@ihsm/ui-shared';
import React, { useMemo, useState, useEffect } from 'react';
import { useCurrentEntity } from 'scenes/portfolios/hooks';
import { useGetPositionsQuery } from 'services/newApi/positionsApi';
import { FullViewLoading } from 'shared/components/FullViewLoading';
import { PortfoliosSceneGrid } from 'shared/components/ReactDataGrid/PortfoliosSceneGrid/components/PortfoliosSceneGrid';
import { columns } from 'shared/components/ReactDataGrid/PortfoliosSceneGrid/utils';
import { mapFundDrilldownTable } from 'shared/mappers';
import { formatDateForURL, sortByComponentVar } from 'shared/utils';
import { useActions, useAppSelector } from 'state/store';
import './PortfoliosFundTable.scss';

export const PortfoliosFundTable: React.FC<{
  gridExportRef: React.RefObject<ExportGridRef>;
}> = ({ gridExportRef }): JSX.Element => {
  const [skip, setSkip] = useState<boolean>(true);
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const { selectedValuationDate: valuationDate } = useAppSelector(
    (state) => state.valuationDatesState
  );
  const { selectedContext } = useAppSelector((state) => state.contextsState);

  const { setShowFullLoadingView } = useActions();
  const { selectedEntity, positionType } = useCurrentEntity();

  const {
    data: positionList = [],
    isError,
    isLoading,
  } = useGetPositionsQuery(
    {
      selectedContext,
      selectedFund: selectedEntity,
      positionType,
    },
    { skip }
  );

  const positionListSorted = [...positionList].sort(sortByComponentVar);

  const exportFileName = `Portfolios_${selectedEntity}_${formatDateForURL(
    new Date()
  )}`;

  const dataAll = useMemo(
    () => mapFundDrilldownTable(positionListSorted),
    [positionListSorted]
  );

  useEffect(() => {
    if (valuationDate && selectedEntity && skip) {
      setSkip(false);
      setShowLoading(true);
    }
  }, [selectedEntity, setShowFullLoadingView, skip, valuationDate]);

  useEffect(() => {
    if ((positionList?.length && !isLoading) || isError) setShowLoading(false);
  }, [isError, isLoading, positionList, setShowFullLoadingView]);

  return (
    <div className="bottom-section-wrapper all">
      <div>
        <FullViewLoading
          forceLoadingScreen={showLoading}
          forceNoDataScreen={isError}
        >
          <PortfoliosSceneGrid
            data={dataAll}
            columns={columns}
            gridExportRef={gridExportRef}
            exportFileName={exportFileName}
          />
        </FullViewLoading>
      </div>
    </div>
  );
};
